import { render, staticRenderFns } from "./BrandHead.vue?vue&type=template&id=5c1b92ec&scoped=true"
import script from "./BrandHead.vue?vue&type=script&lang=js"
export * from "./BrandHead.vue?vue&type=script&lang=js"
import style0 from "./BrandHead.vue?vue&type=style&index=0&id=5c1b92ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1b92ec",
  null
  
)

export default component.exports